<template>
    <div class="protocolChange">
        <div class="section">
            <div class="search">
                <div class="searchLeft">
                    <button type="button" class="button-upload" @click="multiBind()">
                        {{ $t('recharge.remedy_title') }}
                    </button>
                </div>

            </div>
        </div>


        <binding-dialog :title="$t('recharge.remedy_title')"  :class="{ 'showDialog': dialogAdd, 'hideDialog': !dialogAdd }"
            :visible.sync="dialogAdd" width="40vw" noFooter>
            <div slot="content">
                <div class="upload-contents"  @click="$refs.fileUploader.click()">
                    <!-- @click.prevent="$refs.fileUploader.click()" -->
                    <button type="button" class="upload-buttonEquipment">
                        <i class="iconfont icon-shangchuan1"></i>
                        <!-- {{$t('datalogger.Upload')}} -->
                    </button>
                    <div class="upload-tip">{{ $t('recharge.upload_tip') }}</div>
                    <input type="file" class="upload-input" ref="fileUploader"
                        accept=".txt"
                        @change="uploadfile($event)" />

                </div>
                <div style="text-align:right;">

                    <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('binding.cancel')}}</button> -->
                </div>
            </div>
            <div slot="footer">
                <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
                <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
            </div>
        </binding-dialog>
    </div>
</template>
<script>
import bindingDialog from "@/components/dialognew";
export default {
    components: {
        bindingDialog
    },
    data() {
        return {
            dialogAdd: false,

        };
    },
    computed: {
    },
    watch: {
    },
    created() {
    },
    methods: {

        multiBind() {
            this.dialogAdd = true;
            // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
            this.$nextTick(() => {
                this.$refs.fileUploader.value = null;
                this.desc = null;
            });
        },
        //批量绑定上传
        uploadfile(event) {
            // this.$refs.upload.clearFiles()
            let file = event.target.files[0];
            // if (file.size > 8 * 1024 * 1024) {
            //     this.$message.error(this.$t("createPlant.fileExceed"));
            //     return;
            // }
            let suffix = file.name.split(".").slice(-1)[0];
            if (suffix !== "txt") {
                this.$message.error(this.$t('datalogger.upload_err'));
                return;
            }
            this.$request.uploadBounding('adminUpdateGongTianOrder', file).then(res => {
                if (res.err === 0) {
                    this.$message.success(this.$t("createPlant.uploadSuccess"));
                    this.dialogAdd = false;
                } else {
                    this.$message.error(res.desc);
                }
            });
        },

    }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.protocolChange {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 20px;
    // background-color: rgb(34, 45, 53);
    overflow: auto;

    .section {
        display: flex;
        flex: 1;
        padding: 0px;
        flex-direction: column;
        border-radius: 0px;
        border: none;
        background: rgb(34, 45, 53);
        position: relative;
        overflow: hidden;

        /deep/.el-icon-loading {
            font-size: 28px;
        }

        .search {
            margin: 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgb(34, 45, 53);

            .searchLeft {
                .button-upload {
                    display: flex;
                    //多语言状态下文字间隔优化
                    line-height: 16px;
                    justify-content: space-between;
                    align-items: center;
                    width: 120px;
                    height: 48px;
                    background: @primaryTextColor;
                    color: rgb(34, 45, 53);
                    font-size: 14px;
                    margin: 10px;
                    border-radius: 5px;
                    border: none;
                    cursor: pointer;

                }
            }

            .searchRight {
                display: flex;
                justify-content: flex-end;

                .adminSearch {
                    border-left: 1px solid #7B8395;
                    display: flex;
                    justify-content: flex-start;

                    .searchAll {
                        /deep/.el-input__inner {
                            width: 220px;
                            padding-left: 10px;
                        }
                    }

                    .search-device {
                        display: inline-block;
                        line-height: 48px;
                        padding: 0 15px;
                        width: 100%;
                        font-size: 14px;
                        background: #202D35;
                        color: #33FFB6;
                        cursor: pointer;

                        &:hover {
                            background: @primaryColorTransparency30;
                            color: rgb(255, 255, 255, 1);
                        }
                    }

                    .search-hide {
                        display: inline-block;
                        // position: absolute;
                        // right: -58px;
                        // line-height: 48px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 0 15px;
                        font-size: 14px;
                        background: #202D35;
                        color: #7B8395;
                        border-left: 1px solid #7B8395;
                        cursor: pointer;

                        &:hover {
                            background: @primaryColorTransparency30;
                            color: rgb(255, 255, 255, 1);
                        }
                    }
                }
            }

            .statusName {
                padding: 0 16px;
                color: #ADB9C0;
                font-size: 12px;
                line-height: 48px;
                font-weight: 700;
            }

            .statusList {
                cursor: pointer;
                padding: 0 16px;
                color: #70818C;
                font-size: 14px;
                height: 48px;
                line-height: 48px;
            }

            .active {
                color: #00FEBB;
                border-bottom: 2px solid #00FEBB;
            }

            .search-label {
                display: inline-block;
                color: #ffffff;
                font-weight: bold;
                line-height: 48px;
                font-size: 14px;
                padding-left: 16px;
            }

            /deep/.el-select {
                width: 100px;
                border-right: 1px solid #738089;
            }

            /deep/.el-select:hover {
                background: @primaryColorTransparency30;
            }

            /deep/.el-input {
                width: 100%;
                text-align: center;
            }

            /deep/.el-input__inner {
                background: transparent;
                border: none;
                height: 48px;
                line-height: 48px;
                color: #ffffff;
                padding: 0 16px;
            }

            /deep/.el-input__suffix {
                right: 0px;
            }

            .button {
                height: 48px;
                line-height: 48px;
                padding: 0 25px;
                margin-top: 0px;
                color: @primaryTextColor;
                background: transparent;
                border: none;
            }

            .batch-alert {
                height: 48px;
                line-height: 48px;
            }

            // 添加数采器
            .button-addscq {
                // width: 114px;
                height: 48px;
                background: @primaryTextColor;
                color: rgb(34, 45, 53);
                font-size: 14px;
                border-radius: 0px;
                border: none;
                cursor: pointer;

                span {
                    font-size: 14px;
                }

                i {
                    margin-left: 10px;
                }
            }
        }





    }
}

::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
}
</style>
<style lang="less">
.protocolChange {

    .upload-contents {
        border-radius: 6px;
        border: 1px dashed rgba(255, 255, 255, 0.5);
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        .upload-buttonEquipment {
            background: transparent;
            border: none;
            // cursor: pointer;
            padding: 6px 16px 6px 10px;
            color: rgba(255, 255, 255, 0.5);
            font-size: 14px;

            i {
                color: rgb(56, 165, 118);
                font-size: 32px;
            }
        }
    }

    .upload-input {
        display: none;
    }


}
</style>